import { useTranslation } from 'react-i18next';

import { ApplicationInsightsTrackerException } from 'library/components/track/ApplicationInsightsTrackerException';

import { ErrorDetails } from './ErrorDetails';
import { ErrorFallbackProps } from './ErrorFallback';
import { toError } from './toError';

export const ErrorComponentFallback = (props: ErrorFallbackProps) => {
	const { t } = useTranslation(['error', 'home']);

	return (
		<ErrorDetails
			description={t('error:contact-support')}
			subtitle={t('error:application-crash')}
			title={t('error:unauthenticated-title')}>
			<ApplicationInsightsTrackerException
				metric={{ exception: toError(props.error) }}
			/>
		</ErrorDetails>
	);
};
